var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistrautoRLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1042_9138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2999 9.69H38.8899V16.19H78.2999V9.69Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2999 26.95H38.8899V33.45H78.2999V26.95Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2999 44.2H38.8899V50.7H78.2999V44.2Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2999 78.71H38.8899V85.21H78.2999V78.71Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2999 95.97H38.8899V102.47H78.2999V95.97Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2999 113.23H38.8899V119.73H78.2999V113.23Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.78 0H0V8.63H38.78V0Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.78 17.26H0V25.89H38.78V17.26Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.78 34.52H0V43.15H38.78V34.52Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.78 51.76H0V60.39H38.78V51.76Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.78 69.02H0V77.65H38.78V69.02Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.78 86.28H0V94.91H38.78V86.28Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.78 103.54H0V112.17H38.78V103.54Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.78 120.78H0V129.41H38.78V120.78Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.78 138.04H0V146.67H38.78V138.04Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.14 19.2H78.3999V23.94H118.14V19.2Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.45 36.45H78.3999V41.19H133.45V36.45Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.67 53.71H78.3999V58.45H146.67V53.71Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.45 70.97H78.3999V75.71H133.45V70.97Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.27 88.22H78.3999V92.96H104.27V88.22Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.14 105.47H78.3999V110.21H118.14V105.47Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.45 122.73H78.3999V127.47H133.45V122.73Z",
    fill: "#DFFFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.67 139.99H78.3999V144.73H146.67V139.99Z",
    fill: "#DFFFB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1042_9138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 147,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrautoRLight);
export default __webpack_public_path__ + "static/media/registrauto-r-light.100090d7f694ec39c06a9926dd3c6a78.svg";
export { ForwardRef as ReactComponent };